import React, { useState, useEffect, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { useFetch, usePost, useDelete } from '../../../components/component-items/helpers'
import { globalState } from '../../../store'
import CardLoading from '../../../components/component-items/loading-popover'
import GenericModal from '../../../components/component-items/modal'
import GlobalStyles from '../../../components/component-items/styles'
import { DragNDropMany } from '../../../components/component-items/dragndrop'
import ImageZoom from 'react-medium-image-zoom'
import { LabelStyled } from './styles'
import useEmblaCarousel from 'embla-carousel-react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import { faPrint, faGem, faTrashAlt } from '@fortawesome/pro-duotone-svg-icons'

export const GoldenSampleUpload = ({ open, setOpen }: any) => {
  const params: any = useParams()
  const project = params.id
  const [files, setFiles] = useState<File[]>([])
  const {
    state: { csrf },
  } = globalState()

  const updateNotes = useCallback(() => {
    const formData = new FormData()
    files.forEach((file) => formData.append(file.name, file))
    formData.append('golden-sample', 'true')

    const reload = true
    const stringifyBody = false
    usePost(`/api/inventory/project/${project}/details/`, formData, csrf, reload, stringifyBody)
  }, [files, csrf, project])

  return (
    <GenericModal
      heading="Upload Golden Samples"
      show={open}
      size="lg"
      onHide={() => setOpen(false)}
      buttons={<GlobalStyles.Button onClick={updateNotes}>Update</GlobalStyles.Button>}
    >
      <div style={{ minHeight: 100, padding: '1em 1em 0' }}>
        {/* @ts-ignore */}
        <DragNDropMany {...{ files, setFiles }} image_only />
      </div>
    </GenericModal>
  )
}

export const GoldenSample = () => {
  const params: any = useParams()
  const project = params.id
  const {
    state: { csrf, userIsWarehouse },
  } = globalState()

  const { response, loaded, error, placeholder }: any = useFetch(`/api/inventory/project/${project}/samples/`, {}, 60)
  const images = loaded ? response.samples : []
  const total = images.length

  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true })
  const [currentSlide, setCurrentSlide] = useState(0)

  useEffect(() => {
    if (!emblaApi) return

    const onSelect = () => {
      setCurrentSlide(emblaApi.selectedScrollSnap())
    }

    emblaApi.on('select', onSelect)
    onSelect() // set initial slide immediately

    // ✅ Clean up safely when emblaApi changes or component unmounts
    return () => {
      emblaApi.off('select', onSelect)
    }
  }, [emblaApi])

  const handlePrev = () => emblaApi && emblaApi.scrollPrev()
  const handleNext = () => emblaApi && emblaApi.scrollNext()
  const handleDelete = (id: string | number) => useDelete(`/api/inventory/project/${project}/sample/${id}/`, csrf)

  return (
    <LabelStyled>
      <div className="datatable__header">
        <div className="datatable__title">
          <h3>Golden Sample</h3>
          {images.length > 0 && (
            <div>
              <a href={images[currentSlide].url}>
                <button>
                  <FontAwesomeIcon icon={faPrint} />
                </button>
              </a>
              {userIsWarehouse && (
                <button onClick={() => handleDelete(images[currentSlide].id)}>
                  <FontAwesomeIcon icon={faTrashAlt} />
                </button>
              )}
              {total > 1 && (
                <>
                  <button onClick={handlePrev}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                  </button>
                  <button onClick={handleNext}>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </button>
                </>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="order-section embla" ref={emblaRef}>
        <div className="embla__container">
          {images.length > 0 ? (
            images.map((img: any, id: number) => (
              <div className="embla__slide" key={id}>
                <ImageZoom>
                  <img src={img.url} alt="Golden Sample" className="img" />
                </ImageZoom>
              </div>
            ))
          ) : (
            <div className="no-label">
              <div role="img" aria-label="none">
                <FontAwesomeIcon icon={faGem} />
              </div>
              No Golden Sample
            </div>
          )}
        </div>
      </div>

      {!loaded && <CardLoading text={placeholder} error={error} />}
    </LabelStyled>
  )
}
